// extracted by mini-css-extract-plugin
export default {"box":"Box_box__8+8oc","box_items":"Box_box_items__1AaGh","backgroundContent":"Box_backgroundContent__lboGw"};